const AsphaltEmissionType = {
    'state': null,
    'material': {
        'bitumenContent': 0,
        'bitumenImpact': 0,
        'gravelImpact': 0,
        'sandImpact': 0,
        'rapContent': 0,
        'wapContent': 0,
        'total': 0
    },
    'energy': {
        'asphaltHeatingImpact': 0,
        'total': 0
    },
    'transportation': {
        'transportationGHG': 0,
        'total': 0
    },
    'total': 0,
};

export default AsphaltEmissionType;
